export enum RolesPermissionsPermissions {
  VIEW_ROLES_AND_PERMISSIONS = "view_roles_and_permissions",
  CREATE_ROLES_AND_PERMISSIONS = "create_roles_and_permissions",
  UPDATE_ROLES_AND_PERMISSIONS = "update_roles_and_permissions",
  DELETE_ROLES_AND_PERMISSIONS = "delete_roles_and_permissions",
  ARCHIVE_ROLES_AND_PERMISSIONS = "archive_roles_and_permissions",
}

export const RolesPermissionsPermissionsText: Record<
  RolesPermissionsPermissions,
  string
> = {
  [RolesPermissionsPermissions.VIEW_ROLES_AND_PERMISSIONS]:
    "View Roles and Permissions",
  [RolesPermissionsPermissions.CREATE_ROLES_AND_PERMISSIONS]:
    "Create Roles and Permissions",
  [RolesPermissionsPermissions.UPDATE_ROLES_AND_PERMISSIONS]:
    "Update Roles and Permissions",
  [RolesPermissionsPermissions.DELETE_ROLES_AND_PERMISSIONS]:
    "Delete Roles and Permissions",
  [RolesPermissionsPermissions.ARCHIVE_ROLES_AND_PERMISSIONS]:
    "Archive Roles and Permissions",
};
